import React, { Component } from 'react';
//import { Link } from 'react-router-dom';
//import './App.css';
import firebase from './../Firestore'

class CategoriaSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categorias: [],
      categoriaSeleccionada: this.props.valorActual
    };
    this.categoriaIdSeleccionada = React.createRef();
     //console.log("this.props.categoriaID en constr", this.props.categoriaID)

    this.consultoDB = false;

  }


levantarCategoriaDB(){
  //console.log("CONSULTA DB" )
  var currentComponent = this
  var db = firebase.firestore();



  db.collection("categoria").orderBy("orden").get().then(function(querySnapshot) {
          let categorias = []
          querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots

              if(currentComponent.props.esAdicional){
                // solo perimte adicionales para el diseno pizza
                if(doc.data().diseno === "pizza"){
                  categorias.push({
                    id: doc.id,
                    nombre: doc.data().nombre
                  })
                }
              } else {
                categorias.push({
                  id: doc.id,
                  nombre: doc.data().nombre
                })
              }



          });
          //console.log("llego aca")
          currentComponent.setState({
             categorias
          }) ;
      })
      .catch(function(error) {
          console.log("Error getting documents: ", error);
      });

  //this.test = "test 2"
  //console.log("test", this.test)
  this.consultoDB = true;
}

componentDidUpdate(prevProps){
  if(!this.consultoDB) this.levantarCategoriaDB(this.props.categoriaID);

  if(this.props.valorActual !== prevProps.valorActual){
    this.setState({
       categoriaSeleccionada: this.props.valorActual
    }) ;
  }


  //console.log("this.props.valorActual", this.props.valorActual)
  //console.log("did update ", this.props.categoriaID )
}

  async componentDidMount() {
    //var categoriaID = await this.props.categoriaID;
    this.levantarCategoriaDB()



  }


  onChange = (e) => {

    //console.log("en categ select", e.target.name, e.target.value)
    this.setState({
       categoriaSeleccionada: e.target.value
    }) ;


  }

  render() {
    // let Items = ""
    // for(let categoria in this.state.categorias){
    //     Items += `<option value="${categoria.id}">${categoria.nombre}</option>`
    // }

//console.log(this.props.categoriaID)

    return (

      <select value={this.state.categoriaSeleccionada} className="custom-select" ref={this.props.categoriaID} onChange={event => this.onChange(event)}>
      {this.state.categorias.map((categoria, index, arr) =>
        <option key={categoria.id} value={categoria.id}>{categoria.nombre}</option>

      )}
    </select>









    );
  }
}

export default CategoriaSelector;
